import { camelToProperCase } from '@easeltv/utilities';
import { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { useDictionary } from '../../../hooks/useDictionary/useDictionary';
import { Field } from '../../../providers/RegistrationProvider/RegistrationProvider.helpers';
import { replaceWithLink } from '../../../utilities';
import ErrorSummaryAtom from '../../Atoms/ErrorSummaryAtom';
import { FormStateI, renderFormInput } from './FormBlock.helpers';
import { Disclaimer, StyledFormBlock, SubmitButton } from './FormBlock.styled';

/* ---------------------------------- Types --------------------------------- */

export interface FormBlockDumbI {
    fields: Field[];
    handleOnSubmit: (e: FormEvent) => void;
    labels: {
        submitLabel: string;
        disclaimer?: {
            text: string;
            label: string;
            url: string;
        };
    };
    state: FormStateI;
    updateField: (id: string) => (value: unknown) => void;
    forgotPassword: string | undefined;
    isSubmitting: boolean;
}

/* -------------------------------- Component ------------------------------- */

/**
 * FormBlockDumb
 *
 * @param props FormBlockDumbI
 * @returns JSX.Element
 */
const FormBlockDumb = ({
    fields,
    handleOnSubmit,
    labels: { disclaimer, submitLabel },
    state,
    forgotPassword,
    updateField,
    isSubmitting,
}: FormBlockDumbI) => {
    const dictionary = useDictionary();

    return (
        <StyledFormBlock onSubmit={handleOnSubmit} noValidate>
            {fields.map((field) =>
                renderFormInput(
                    {
                        ...field,
                        label:
                            dictionary[field.label ?? ''] ??
                            camelToProperCase(field.id),
                    },
                    state,
                    updateField,
                ),
            )}
            <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Loading...' : submitLabel}
            </SubmitButton>
            <ErrorSummaryAtom errors={state.errors} />
            {forgotPassword && (
                <Disclaimer>
                    <Link to="/forgot">{forgotPassword}</Link>
                </Disclaimer>
            )}
            {disclaimer && (
                <Disclaimer>
                    {replaceWithLink(disclaimer.text, [
                        {
                            label: disclaimer.label,
                            url: disclaimer.url,
                        },
                    ])}
                </Disclaimer>
            )}
        </StyledFormBlock>
    );
};
/* --------------------------------- Export --------------------------------- */

export default FormBlockDumb;
